$(document).ready(function() {

  // Initialize slick03
  $('.slick03').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 1500,
    infinite: true,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "12%",
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });
    
  // Initialize slick-re
  $('.slick-re').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 1500,
    infinite: true,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "7%",
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });

  // touchmove対応
  $('.slick03').on('touchmove', function() {
    $(this).slick('slickPlay');
  });

  $('.slick-re').on('touchmove', function() {
    $(this).slick('slickPlay');
  });

});


 // ====アニメーションjs =====//
function sliderSetup(sliderId, targetImgId) {
  const slider = document.getElementById(sliderId);
  const arrows = document.querySelectorAll(`.arrow[data-target="${sliderId}"]`);
  const targetImg = document.getElementById(targetImgId);

  let items = Array.from(slider.children);
  const originalCount = items.length;

  // 無限ループ用に複製
  items.forEach(item => slider.appendChild(item.cloneNode(true)));
  items = Array.from(slider.children);

  let index = 0;
  let isTransition = true;
  let autoTimer = null;

  function getItemWidth() {
    const gap = parseFloat(getComputedStyle(slider).gap) || 0;
    return items[0].offsetWidth + gap;
  }

  function move() {
    slider.style.transition = isTransition ? "transform 0.8s ease" : "none";
    slider.style.transform = `translateX(${-index * getItemWidth()}px)`;
  }

  // =====================
  // 自動スライド
  // =====================
  function startAuto() {
    if (autoTimer) return;
    autoTimer = setInterval(() => {
      index++;
      move();

      if (index >= originalCount) {
        setTimeout(() => {
          isTransition = false;
          index = 0;
          move();
          requestAnimationFrame(() => { isTransition = true; });
        }, 800);
      }
    }, 4500);
  }

  function stopAuto() {
    clearInterval(autoTimer);
    autoTimer = null;
  }

  // =====================
  // 選択反映（クリックでON / OFF）
  // =====================
  let isDragging = false;

  items.forEach(item => {
    item.addEventListener("click", () => {
      if (isDragging) return;

      const isActive = item.classList.contains("active");
      items.forEach(i => i.classList.remove("active"));

      if (!isActive) {
        item.classList.add("active");
        if (targetImg) targetImg.src = item.dataset.src;
      } else {
        if (targetImg) targetImg.src = "";
      }
    });
  });

  // =====================
  // 矢印クリック
  // =====================
  arrows.forEach(a => {
    a.addEventListener("click", () => {
      if (a.classList.contains("arrow-right")) index++;
      else index--;

      if (index < 0) index = originalCount - 1;
      move();

      if (index >= originalCount) {
        setTimeout(() => {
          isTransition = false;
          index = 0;
          move();
          requestAnimationFrame(() => { isTransition = true; });
        }, 800);
      }
    });
  });

  // =====================
  // スワイプ（選択ON/OFFと両立）
  // =====================
  const wrapper = slider.parentElement;
  let startX = 0;
  let moveX = 0;

  wrapper.addEventListener("touchstart", e => {
    stopAuto();
    startX = e.touches[0].clientX;
    moveX = 0;
    isDragging = false;
  });

  wrapper.addEventListener("touchmove", e => {
    moveX = e.touches[0].clientX - startX;

    // 10px以上動いたらスワイプ扱い
    if (Math.abs(moveX) > 10) {
      isDragging = true;
    }
  });

  wrapper.addEventListener("touchend", e => {
    const diff = e.changedTouches[0].clientX - startX;

    if (Math.abs(diff) > 40) {
      index += diff < 0 ? 1 : -1;

      if (index < 0) index = originalCount - 1;
      move();

      if (index >= originalCount) {
        setTimeout(() => {
          isTransition = false;
          index = 0;
          move();
          requestAnimationFrame(() => { isTransition = true; });
        }, 800);
      }
    }

    startAuto();
  });

  slider.addEventListener("mouseenter", stopAuto);
  slider.addEventListener("mouseleave", startAuto);

  startAuto();
}

// 初期化
sliderSetup("pierceSlider", "pierceImg");
sliderSetup("charmSlider", "charmImg");

// ぼやややーーっとフェードイン（blur + opacity）
function blurFadeAnime() {
  const elements = document.querySelectorAll('.blurFadeText');
  const scroll = window.scrollY || window.pageYOffset;
  const windowHeight = window.innerHeight;

  elements.forEach(elem => {
    const elemPos = elem.getBoundingClientRect().top + scroll + 50;

    if (scroll >= elemPos - windowHeight) {
      elem.classList.add('blurFade');
      elem.style.opacity = '1';
    } else {
      elem.classList.remove('blurFade');
      elem.style.opacity = '0';
    }
  });
}

// runAllAnimations はそのまま使える
function runAllAnimations() {
  fadeAnime();      // 既存の jQuery 依存部分を必要に応じて置き換える
  fadeInAnime();    // 同上
  blurFadeAnime();  // バニラJS版を呼び出す
}

// スクロールイベントで実行
window.addEventListener('scroll', blurFadeAnime);
window.addEventListener('load', blurFadeAnime); // ページロード時もチェック